import { Inline, Stack } from '@atlaskit/primitives/compiled';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { type JSX } from 'react/jsx-runtime';

const placeholderStyles = css({
	height: token('space.500', '90px'),
	padding: token('space.400', '32px'),
	'@media (max-width: 1024px)': {
		padding: token('space.200', '16px'),
	},
	overflow: 'hidden',
	border: `1px solid ${token('color.border', '#091E4224')}`,
	display: 'flex',
	flex: '1 100%',
	borderRadius: token('radius.small', '4px'),
	justifyContent: 'space-between',
	alignItems: 'center',
	marginBottom: token('space.300', '24px'),
});

export const ConfluenceHomeBannerPlacementSkeleton = (): JSX.Element => {
	return (
		<UFOLoadHold name="confluence-home-banner-loading">
			<div css={placeholderStyles} data-testid="confluence-home-banner-loading-skeleton">
				<Inline alignInline="center" alignBlock="center" spread="space-between" grow="fill">
					<Skeleton width="145px" height="44px" borderRadius="3px" isShimmering />
					<Stack space="space.100">
						<Skeleton width="460px" height="25px" borderRadius="3px" isShimmering />
						<Skeleton width="460px" height="25px" borderRadius="3px" isShimmering />
					</Stack>
					<Skeleton width="195px" height="40px" borderRadius="3px" isShimmering />
				</Inline>
			</div>
		</UFOLoadHold>
	);
};

export default ConfluenceHomeBannerPlacementSkeleton;
